import AdyenCore from '@adyen/adyen-web/dist/types/core';
import { createContext } from 'react';
import {
  Configuration as EpaymentConfig,
  EpaymentApi,
} from './generated-sources/epayment-internal-api';
import {
  Configuration as PEConfig,
  CardEnrollmentApi,
  FCSPApi,
} from './generated-sources/payments-api';
import prepAdyenSdk, { SdkType } from './lib/adyenSdk';
import { FakeEpaymentApi } from './lib/dev/epaymentApi';
import { FakeFCSPApi } from './lib/dev/peApi';
import {
  Brand,
  CurrentLocale,
  CurrentTheme,
  currentTranslations,
  Locale,
  TextLocalisation,
} from './lib/localisation';

import { getParameterByName, getRootHost, PARAMS } from './lib/util';

export enum Env {
  DEV = 'DEV',
  UAT = 'UAT',
  MT = 'MT',
  PROD = 'PROD',
}

export interface OurContext {
  env: Env;
  apiUrl: string;
  peApiAuth: string;
  peApiSubscriptionId: string;
  epaymentsApiAuth: string;
  epaymentApiSubscriptionId: string;
  isDev: boolean;
  locale: Locale;
  enrollmentAdyenSdk: () => Promise<AdyenCore>;
  fcspAdyenSdk: () => Promise<AdyenCore>;
  cardEnrollmentApi: CardEnrollmentApi;
  fscpApi: FCSPApi;
  epaymentApi: EpaymentApi;
  texts: TextLocalisation;
  host: string;
  currentTheme: Brand;
}
const localOrUat = window.location.hostname === 'localhost' ? Env.DEV : Env.UAT;
const env: Env = window.location.hostname === 'cards.vipps.no' ? Env.PROD : localOrUat;
const apiUrl =
  env === Env.PROD
    ? 'https://api.vipps.no'
    : env === Env.UAT
    ? 'https://ece46ec4-6f9c-489b-8fe5-146a89e11635.tech-02.net'
    : 'http://localhost:8080';
const token = getParameterByName(PARAMS.TOKEN) || '';
const epaymentToken = getParameterByName(PARAMS.CARD_PAGE_TOKEN) || '';
export const context: OurContext = {
  env,
  peApiAuth: token,
  epaymentsApiAuth: epaymentToken,
  apiUrl,
  peApiSubscriptionId:
    env === Env.PROD ? '21ce83c2dafa482ba8327a049a75646a' : 'e1711740804740eab0fa7ac1a43a901d',
  epaymentApiSubscriptionId:
    env === Env.PROD ? '7215c414853a48f896f87ddf59116dae' : 'c9b7e8404c2a49b6a5317687be14617d',
  get isDev() {
    // computes fresh based on current env setting and url
    return this.env === Env.DEV;
  },
  currentTheme: CurrentTheme,
  locale: CurrentLocale,
  enrollmentAdyenSdk: prepAdyenSdk(env, SdkType.ENROLLMENT),
  fcspAdyenSdk: prepAdyenSdk(env, SdkType.FSCP),
  cardEnrollmentApi: new CardEnrollmentApi(
    new PEConfig({
      basePath: `${apiUrl}/adyen-card-enrollment`,
    })
  ),
  fscpApi:
    env === Env.DEV
      ? new FakeFCSPApi()
      : new FCSPApi(
          new PEConfig({
            basePath: `${apiUrl}/adyen-card-enrollment`,
          })
        ),
  epaymentApi:
    env === Env.DEV
      ? new FakeEpaymentApi(
          // new EpaymentApi(
          new EpaymentConfig({
            basePath: `http://localhost:8080/vipps-epayment-api`,
            accessToken: `Bearer ${epaymentToken}`,
          })
        )
      : new EpaymentApi(
          new EpaymentConfig({
            basePath: `${apiUrl}/epayment/internal`,
            accessToken: `Bearer ${epaymentToken}`,
          })
        ),
  texts: currentTranslations,
  host: getRootHost(),
};

export const AppContext = createContext(context);
